import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  applicantsList: any;
  resendVerificationLinkStatus: StateStatus | null | undefined;
}

const initialState: IState = {
  applicantsList: {
    status: null,
    data: null,
  },
  resendVerificationLinkStatus: null,
};

const ApplicantsReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_APPLICANTS:
      return {
        ...state,
        applicantsList: {
          ...state.applicantsList,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.applicantsList.data
              : action.data,
        },
      };
    case Types.RESEND_VERIFICATION_LINK:
      return {
        ...state,
        resendVerificationLinkStatus: action.status,
      };
    default:
      return {
        ...state,
      };
  }
};

export default ApplicantsReducer;
